<template>
  <div class="container">
    <!-- <BaseLoader
      v-if="cargando"
    /> -->
    <!-- <table v-else> -->
    <div class="contenedor_filtros_mentorias">
      <div class="form_section">
        <label for="alumno_id" class="label_crear_mentor">Nombre del profe</label>
        <v-select
          class="contenedor_select_buscador"
          label="item_data"
          :reduce="profesores => profesores.persona_id"
          :options="profesores"
          :disabled="cargando"
          v-model.number="profe.persona_id"
          @input="traerAlumnosPorProfe()"
        >
          <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
            <p>La persona ingresada no figura en nuestros registros.</p>
          </span>
        </v-select>
      </div>
    </div>
    <p v-if="this.alumnos.length == 0" class="no-resultado">No hay alumnos registrados al profe seleccionado</p>
    <div class="contenedor_socios_lista" v-else>
      <p class="cantidad_profe_por_alumno">Cantidad de alumnos: {{ this.alumnos.length }}</p>
      <table id="tabla-socio-lista">
        <thead>
          <th>Alumno</th>
          <th>Profe</th>
        </thead>
        <tbody>
          <AlumnosPorProfeListaItem
            v-for="alumno in alumnos"
            :alumno="alumno"
            :key="alumno.persona_id"
          ></AlumnosPorProfeListaItem>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import AlumnosPorProfeListaItem from '../components/AlumnosPorProfeListaItem.vue'
import mentorService from '../services/mentor'
import asociadoService from '../services/asociado'
export default {
  name: 'AlumnosPorProfeLista',
  components: {
    AlumnosPorProfeListaItem
    // Header2
  },
  data: function () {
    return {
      cargando: false,
      mentorias: [],
      profesores: [],
      alumnos: [],
      mentores: [],
      mentoreados: [],
      condiciones: [],
      profe: {
        persona_id: null
      }
    }
  },
  methods: {
    selectUpdateHandler (value) {
      console.log('selectUpdateHandler', value)
    },
    traerAlumnosPorProfe () {
      // if (event.target.value != null) {
      //   console.log('ewer66666666666werewrew')
      // }
      console.log('ewerwerewrew')
      console.log(this.profe.persona_id)
      // this.busqueda = null
      // this.cargando = true
      if (this.profe.persona_id === null) {
        mentorService
          .traerAlumnosPorProfeTodos()
          .then(respuesta => {
            // this.cargando = false
            this.alumnos = respuesta
            console.log('Todos los alumnos x profe', respuesta)
          })
      } else {
        mentorService
          .traerAlumnosPorProfe(this.profe.persona_id)
          .then(respuesta => {
            // this.cargando = false
            // this.currentPage = 1
            // this.socios = []
            // this.socios = respuesta
            console.log('INFO POR FILTRO', respuesta)
            this.alumnos = respuesta
            // this.pageCount = Math.ceil(this.socios.length / this.sizePaginado)
            // this.exportarExcel(respuesta)
          })
      }
    }
  },
  mounted: function () {
    asociadoService
      .traerProfesoresFormadoresTodos()
      .then(respuesta => {
        // this.cargando = false
        this.profesores = respuesta
        console.log('Profesores:', respuesta)
        this.profesores.map(function (x) {
          x.item_data = x.nombre + ' ' + x.apellido
        })
      })
    mentorService
      .traerAlumnosPorProfeTodos()
      .then(respuesta => {
        // this.cargando = false
        this.alumnos = respuesta
        console.log('Todos los alumnos x profe', respuesta)
      })
  }
}
</script>
